/**
 * AWS Service Price Controller模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const price = {
  //查询实例价格
  getInstancePrice(params) {
    return $http.post(`${global.API_URL}/sme/price/getInstancePrice`, params);
  },
  //查询存储价格
  getStoragePrice(params) {
    return $http.post(`${global.API_URL}/sme/price/getStoragePrice`, params);
  },
  //查询实例CPU和RAM列表
  listInstanceCoreAndRam(params) {
    return $http.post(`${global.API_URL}/sme/price/listInstanceCoreAndRam`, params);
  },
  //查询数据库实例CPU和RAM列表
  listRDSInstanceCoreAndRam(params) {
    return $http.post(`${global.API_URL}/sme/price/listRDSInstanceCoreAndRam`, params);
  },
  //查询数据库实例价格
  getRDSInstancePrice(params) {
    return $http.post(`${global.API_URL}/sme/price/getRDSInstancePrice`, params);
  },
  //查询AWS计算规格
  listCalculationSpecification(params) {
    return $http.post(`${global.API_URL}/sme/price/listCalculationSpecification`, params);
  },
  //查询AWS云平台规格
  selectEc2PriceByInstanceTypeName(params) {
    return $http.post(`${global.API_URL}/sme/price/selectEc2PriceByInstanceTypeName`, params);
  },
  //查询AWS系统
  querySystem(params) {
    return $http.post(`${global.API_URL}/sme/price/querySystem`, params);
  },
  //查询AWS镜像名称
  queryMirrorImageName(params) {
    return $http.post(`${global.API_URL}/sme/price/queryMirrorImageName`, params);
  },
  // 数据库实例类列表
  listDatabaseInstanceClass(params) {
    return $http.post(`${global.API_URL}/sme/price/listDatabaseInstanceClass`,params);
  }
}

export default price;



// WEBPACK FOOTER //
// ./src/api/price.js